import { render, staticRenderFns } from "./coachList.vue?vue&type=template&id=63ed3ab0&scoped=true"
import script from "./coachList.vue?vue&type=script&lang=js"
export * from "./coachList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed3ab0",
  null
  
)

export default component.exports